"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const style_converter_1 = require("../../../views/chart/shared/service/style-converter");
let ScorecardChartControlComponent = class ScorecardChartControlComponent {
    ngOnChanges(changes) {
        if (changes && changes['scoreStyle']) {
            if (this.scoreStyle) {
                this.scoreNgStyle = style_converter_1.StyleConverter.convert(this.scoreStyle);
            }
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ScorecardChartControlComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ScorecardChartControlComponent.prototype, "languageId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ScorecardChartControlComponent.prototype, "score", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_report_export_service_client_js_1.TextStyleDto)
], ScorecardChartControlComponent.prototype, "scoreStyle", void 0);
ScorecardChartControlComponent = __decorate([
    core_1.Component({
        
        selector: "sis-scorecard-chart-control",
        styles: [require('./sis-scorecard-chart-control.component.css')],
        template: require('./sis-scorecard-chart-control.component.html'),
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
], ScorecardChartControlComponent);
exports.ScorecardChartControlComponent = ScorecardChartControlComponent;
//# sourceMappingURL=sis-scorecard-chart-control.component.js.map